export const USER_POPULATE_FULL = [
    "exchange_accounts.bot_configs.userConfig",
    "exchange_accounts.exchange",
    "exchange_accounts.bot_configs",
    "referrals",
    "role",
    "referral.referrer",
    "subscription_tier",
    "taxProfile",
    "pm_paymentMethods",
    "pm_billingData",
];
export const USER_POPULATE_AUTH = ["role", "subscription_tier"];
export const USER_POPULATE_PROFILE = [
    "role",
    "subscription_tier",
    "taxProfile",
    "pm_billingData",
];
export const USER_POPULATE_ME = [
    "role",
    "subscription_tier",
    "taxProfile",
    "pm_billingData",
    "pm_paymentMethods",
    "referrals",
    "referral.referrer",
];
export const USER_POPULATE_LIST = [
    "role",
    "subscription_tier",
    "exchange_accounts.bot_configs",
    "referrals",
    "referral.referrer",
];
export const USER_POPULATE_MINIMAL = ["role"];
export const USER_POPULATE_REFERRAL = [
    "referrals",
    "referral.referrer",
];
// Combined export for convenience
export const USER_POPULATE = {
    FULL: USER_POPULATE_FULL,
    AUTH: USER_POPULATE_AUTH,
    PROFILE: USER_POPULATE_PROFILE,
    ME: USER_POPULATE_ME,
    LIST: USER_POPULATE_LIST,
    MINIMAL: USER_POPULATE_MINIMAL,
    REFERRAL: USER_POPULATE_REFERRAL,
};
